export interface IDateTypes {
  fromDate: string;
  toDate: string;
}

export const DateTypes: IDateTypes = {
  fromDate: "fromDate",
  toDate: "toDate",
};
